import type * as React from 'react';

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

/* Document order is tab order here — nothing in the drawer sets a positive tabindex. */
function tabbableWithin(root: HTMLElement): HTMLElement[] {
  return [...root.querySelectorAll<HTMLElement>(FOCUSABLE)].filter((element) =>
    element.checkVisibility(),
  );
}

/*
 * Tab off either end of a covering drawer and you come back round the other
 * side. What is behind it cannot be seen and cannot be dismissed, so focus
 * landing there strands whoever is driving from the keyboard.
 */
export function containTab(event: React.KeyboardEvent<HTMLElement>): void {
  const tabbable = tabbableWithin(event.currentTarget);
  const edge = event.shiftKey ? tabbable.at(0) : tabbable.at(-1);

  if (!edge || document.activeElement !== edge) {
    return;
  }

  event.preventDefault();
  (event.shiftKey ? tabbable.at(-1) : tabbable.at(0))?.focus();
}
